import { Input } from './input'

export class TextInput extends Input {
    constructor(language: string, inputData?: Partial<Input>) {
        super(language, inputData)
        this.kind = 'plainText'
        this.name = `form_fe['revision.heading_textQuestionItem']`
        this.icon = 'fa fa-text'
    }
}
